module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "layout-block"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.leftContentImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPage),
      expression: "showPage"
    }],
    staticClass: "main"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "open-store"
  }, [_c('h1', [_vm._v("欢迎来到开心云商商家中心")]), _vm._v(" "), (_vm.applyStatus == 1) ? _c('p', [_vm._v("您的申请正在审核中，请耐心等待...")]) : (_vm.applyStatus == 2) ? _c('p', [_vm._v("你已经是联盟商家，编号：" + _vm._s(_vm.sn))]) : (_vm.applyStatus == 4) ? _c('p', [_vm._v("联盟商家已禁用，请联系管理员...")]) : (_vm.applyStatus == 3) ? _c('div', [_c('p', [_vm._v("抱歉，您的申请未通过.......")]), _vm._v(" "), _c('div', [_vm._v("原因: " + _vm._s(_vm.notPassReason))]), _vm._v(" "), _c('div', [(_vm.checked) ? _c('dt', [_c('router-link', {
    attrs: {
      "to": {
        path: '/applyLeague'
      }
    }
  }, [_vm._v("点击修改申请")])], 1) : _c('dt', [_c('span', [_vm._v("点击修改申请")])])]), _vm._v(" "), _c('div', [_c('Checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("我已阅读并同意"), _c('span', {
    staticStyle: {
      "color": "#1e80ff",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.docPage.apply(null, arguments)
      }
    }
  }, [_vm._v("《联盟商家入驻服务协议》")])])], 1)]) : _c('div', [_c('h3', [_vm._v("您现在还不是联盟商家，您可以：")]), _vm._v(" "), _c('div', [_c('em'), _vm._v(" "), _c('dl', [(_vm.checked) ? _c('dt', [_c('router-link', {
    attrs: {
      "to": {
        path: '/applyLeague'
      }
    }
  }, [_vm._v("马上申请联盟商家")])], 1) : _c('dt', [_c('span', [_vm._v("马上申请联盟商家")])]), _vm._v(" "), _c('dd', [_vm._v("填写相关信息，即可免费成为联盟商家。")])])]), _vm._v(" "), _c('div', [_c('Checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("我已阅读并同意"), _c('span', {
    staticStyle: {
      "color": "#1e80ff",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.docPage.apply(null, arguments)
      }
    }
  }, [_vm._v("《联盟商家入驻服务协议》")])])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "apply-img-block"
  }, [_c('div', {
    staticStyle: {
      "background": "#E8F1F8",
      "padding": "8px 10px"
    }
  }, [_vm._v("申请联盟商家需要以下资料")]), _vm._v(" "), _c('div', {
    staticClass: "apply-img"
  }, [_c('div', {
    staticClass: "apply-img-left"
  }, [_c('div', {
    staticClass: "apply-img-box"
  }, [_c('img', {
    staticClass: "apply-img-url",
    attrs: {
      "src": _vm.businessLicence,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marker"
  }, [_vm._v("例")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "apply-img-left"
  }, [_c('div', {
    staticClass: "apply-img-box"
  }, [_c('img', {
    staticClass: "apply-img-url",
    staticStyle: {
      "width": "80%",
      "display": "inherit",
      "margin": "auto"
    },
    attrs: {
      "src": _vm.identityCard,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marker"
  }, [_vm._v("例")])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "apply-img"
  }, [_c('div', {
    staticClass: "apply-img-left"
  }, [_c('div', {
    staticClass: "apply-img-box"
  }, [_c('img', {
    staticClass: "apply-img-url",
    attrs: {
      "src": _vm.doorHeadPhoto,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marker"
  }, [_vm._v("例")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "apply-img-left"
  }, [_c('div', {
    staticClass: "apply-img-box"
  }, [_c('img', {
    staticClass: "apply-img-url",
    attrs: {
      "src": _vm.interior,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "marker"
  }, [_vm._v("例")])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("营业执照")]), _vm._v(" "), _c('div', [_vm._v("需要拍照原件或盖章复印件，证照需要在有效期内。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("身份证(正反面)")]), _vm._v(" "), _c('div', [_vm._v("法定代表人/经营者身份证")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("门头照"), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "500",
      "margin-left": "5px"
    }
  }, [_vm._v("x1")])]), _vm._v(" "), _c('div', [_vm._v("必须为正面全景照。包含完整店名和入口，且店名要与填写的店名一致。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "apply-text"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("内景照")]), _vm._v(" "), _c('div', [_vm._v("需拍摄真是门店环境（如服务场景、工作台、用餐环境等）。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-228e32eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/league-business/createLeague.vue
// module id = 1550
// module chunks = 1